__turbopack_context__.v({
  "container": "features1440px-module-scss-module__Ikj7CW__container",
  "containerCentered": "features1440px-module-scss-module__Ikj7CW__containerCentered" + " " + "features1440px-module-scss-module__Ikj7CW__container",
  "descriptor": "features1440px-module-scss-module__Ikj7CW__descriptor",
  "features1440px": "features1440px-module-scss-module__Ikj7CW__features1440px",
  "icon": "features1440px-module-scss-module__Ikj7CW__icon",
  "icon1": "features1440px-module-scss-module__Ikj7CW__icon1",
  "icon2": "features1440px-module-scss-module__Ikj7CW__icon2",
  "icon6": "features1440px-module-scss-module__Ikj7CW__icon6",
  "imageIcon": "features1440px-module-scss-module__Ikj7CW__imageIcon",
  "imageIcon1": "features1440px-module-scss-module__Ikj7CW__imageIcon1",
  "item1": "features1440px-module-scss-module__Ikj7CW__item1",
  "item11": "features1440px-module-scss-module__Ikj7CW__item11",
  "item2": "features1440px-module-scss-module__Ikj7CW__item2",
  "item4": "features1440px-module-scss-module__Ikj7CW__item4",
  "item5": "features1440px-module-scss-module__Ikj7CW__item5",
  "item6": "features1440px-module-scss-module__Ikj7CW__item6",
  "itemBlock": "features1440px-module-scss-module__Ikj7CW__itemBlock",
  "items": "features1440px-module-scss-module__Ikj7CW__items",
  "label": "features1440px-module-scss-module__Ikj7CW__label",
  "leftcol": "features1440px-module-scss-module__Ikj7CW__leftcol",
  "text": "features1440px-module-scss-module__Ikj7CW__text",
  "text1": "features1440px-module-scss-module__Ikj7CW__text1",
  "text5": "features1440px-module-scss-module__Ikj7CW__text5",
  "title": "features1440px-module-scss-module__Ikj7CW__title",
});
